module.exports = "/ui/1724fd7362cae12e24f68e81848472a1.jpg";